module.exports = __webpack_public_path__ + "img/FPO_jellybean_blazer.ac422b4b.png";